import { render } from "./StatsCountryCount.vue?vue&type=template&id=8d1c8bb2"
import script from "./StatsCountryCount.vue?vue&type=script&lang=js"
export * from "./StatsCountryCount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__